import { render, staticRenderFns } from "./ActiveInfoPage.vue?vue&type=template&id=5292bb9d&"
import script from "./ActiveInfoPage.vue?vue&type=script&lang=ts&"
export * from "./ActiveInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveInfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports